export const dummyDataList = {
  content: [
    {
      sn: 64,
      nm: "등록 테스트",
      addr: "김포",
      daddr: "333333",
      telno: null,
      delYn: "N",
      regDt: "2025.08.28",
      rgtrId: "gripees",
      mdfcnDt: "2025.08.28",
      mdfrId: "gripees",
      elementaryCount: 0,
      middleCount: 0,
      highCount: 0,
      totalStudents: 0,
    },
    {
      sn: 63,
      nm: "11111",
      addr: "22222",
      daddr: "333333",
      telno: null,
      delYn: "N",
      regDt: "2025.08.28",
      rgtrId: "gripees",
      mdfcnDt: "2025.08.28",
      mdfrId: "gripees",
      elementaryCount: 0,
      middleCount: 0,
      highCount: 0,
      totalStudents: 0,
    },
    {
      sn: 46,
      nm: "테스트 센터10",
      addr: "성북구 길음동",
      daddr: "11-22",
      telno: "0200000000",
      delYn: "N",
      regDt: "2025.08.22",
      rgtrId: "gripees",
      mdfcnDt: "2025.08.22",
      mdfrId: "gripees",
      elementaryCount: 3,
      middleCount: 0,
      highCount: 0,
      totalStudents: 3,
    },
    {
      sn: 56,
      nm: "테스트 센터95",
      addr: "성북구 길음동",
      daddr: "11-22",
      telno: "0200000000",
      delYn: "N",
      regDt: "2025.08.22",
      rgtrId: "kelick82",
      mdfcnDt: "2025.08.22",
      mdfrId: "kelick82",
      elementaryCount: 1,
      middleCount: 0,
      highCount: 0,
      totalStudents: 1,
    },
    {
      sn: 54,
      nm: "테스트 센터95",
      addr: "성북구 길음동",
      daddr: "11-22",
      telno: "0200000000",
      delYn: "N",
      regDt: "2025.08.22",
      rgtrId: "kelick82",
      mdfcnDt: "2025.08.22",
      mdfrId: "kelick82",
      elementaryCount: 1,
      middleCount: 0,
      highCount: 0,
      totalStudents: 1,
    },
    {
      sn: 40,
      nm: "테스트 센터95",
      addr: "성북구 길음동",
      daddr: "11-22",
      telno: "0200000000",
      delYn: "N",
      regDt: "2025.08.22",
      rgtrId: "kelick82",
      mdfcnDt: "2025.08.22",
      mdfrId: "kelick82",
      elementaryCount: 0,
      middleCount: 0,
      highCount: 0,
      totalStudents: 0,
    },
    {
      sn: 36,
      nm: "테스트 센터5",
      addr: "성북구 길음동",
      daddr: "11-22",
      telno: "0200000000",
      delYn: "N",
      regDt: "2025.08.22",
      rgtrId: "gripees",
      mdfcnDt: "2025.08.22",
      mdfrId: "gripees",
      elementaryCount: 1,
      middleCount: 0,
      highCount: 0,
      totalStudents: 1,
    },
    {
      sn: 35,
      nm: "테스트 센터95",
      addr: "성북구 길음동",
      daddr: "11-22",
      telno: "0200000000",
      delYn: "N",
      regDt: "2025.08.22",
      rgtrId: "kelick82",
      mdfcnDt: "2025.08.22",
      mdfrId: "kelick82",
      elementaryCount: 0,
      middleCount: 0,
      highCount: 0,
      totalStudents: 0,
    },
    {
      sn: 33,
      nm: "테스트 센터95",
      addr: "성북구 길음동",
      daddr: "11-22",
      telno: "0200000000",
      delYn: "N",
      regDt: "2025.08.22",
      rgtrId: "kelick82",
      mdfcnDt: "2025.08.22",
      mdfrId: "kelick82",
      elementaryCount: 0,
      middleCount: 0,
      highCount: 0,
      totalStudents: 0,
    },
    {
      sn: 24,
      nm: "테스트 센터5",
      addr: "성북구 길음동",
      daddr: "11-22",
      telno: "0200000000",
      delYn: "N",
      regDt: "2025.08.22",
      rgtrId: "gripees",
      mdfcnDt: "2025.08.22",
      mdfrId: "gripees",
      elementaryCount: 1,
      middleCount: 0,
      highCount: 0,
      totalStudents: 1,
    },
  ],
  pageable: {
    pageNumber: 0,
    pageSize: 10,
    sort: {
      empty: false,
      sorted: true,
      unsorted: false,
    },
    offset: 0,
    paged: true,
    unpaged: false,
  },
  last: false,
  totalElements: 13,
  totalPages: 2,
  size: 10,
  number: 0,
  sort: {
    empty: false,
    sorted: true,
    unsorted: false,
  },
  first: true,
  numberOfElements: 10,
  empty: false,
};

export const dummyBoardDataList = {
  content: [
    {
      rowNum: 4,
      type: "자료실",
      title: "테스트 공지사항입니다.",
      createBy: "ADMIN/admin",
      file: "",
      mdfcnDt: "2024-06-01",
      fix: true,
    },
    {
      rowNum: 3,
      type: "공지",
      title: "테스트 공지사항입니다.",
      createBy: "ADMIN/admin",
      file: [{ name: "file1.pdf", url: "/files/file1.pdf" }],
      mdfcnDt: "2024-06-01",
      fix: false,
    },
    {
      rowNum: 2,
      type: "공지",
      title: "테스트 공지사항입니다.",
      createBy: "ADMIN/admin",
      file: "",
      mdfcnDt: "2024-06-01",
      fix: false,
    },
    {
      rowNum: 1,
      type: "공지",
      title: "테스트 공지사항입니다.",
      createBy: "ADMIN/admin",
      file: "",
      mdfcnDt: "2024-06-01",
      fix: false,
    },
  ],
};

export const dummyMatchingDataList = {
  content: [
    {
      rowNum: 3,
      mentor: "mentoer3(mentoer3)",
      subject: "수학",
      schoolLevel: "고등학교 1~2학년",
      menteeCount: 2,
      matchingId: "MAT2024060003",
      createAt: "2024-06-03 14:00",
      updateAt: "2024-06-03 14:00",
    },
    {
      rowNum: 2,
      mentor: "mentoer2(mentoer2)",
      subject: "영어",
      schoolLevel: "중학교 1~3학년",
      menteeCount: 1,
      matchingId: "MAT2024060002",
      createAt: "2024-06-02 14:00",
      updateAt: "2024-06-02 14:00",
    },
    {
      rowNum: 1,
      mentor: "mentoer1(mentoer1)",
      subject: "국어",
      schoolLevel: "고등학교 1~2학년",
      menteeCount: 3,
      matchingId: "MAT2024060001",
      createAt: "2024-06-01 14:00",
      updateAt: "2024-06-01 14:00",
    },
  ],
};

export const dummyEventDataList = {
  content: [
    {
      sn: 1,
      num: 4,
      title: "이벤트 테스트3",
      periodType: "RANGE",
      startDate: "2024-06-10",
      endDate: "2024-06-20",
      status: "종료",
      visible: false,
      createBy: "ADMIN/admin",
      mdfcnDt: "2024-06-01",
    },
    {
      sn: 2,
      num: 2,
      title: "이벤트 테스트2",
      periodType: "ALWAYS",
      startDate: "",
      endDate: "",
      status: "종료",
      visible: false,
      createBy: "ADMIN/admin",
      mdfcnDt: "2024-06-01",
    },
    {
      sn: 3,
      num: 1,
      title: "이벤트 테스트1",
      periodType: "RANGE",
      startDate: "2024-06-01",
      endDate: "2024-06-10",
      status: "진행중",
      visible: true,
      createBy: "ADMIN/admin",
      mdfcnDt: "2024-06-01",
    },
  ],
};

export const dummyClassList = {
  content: [
    {
      num: 1,
      mentor: "김멘토 (mentor01)",
      subject: "수학",
      operatingDate: "2024-06-01",
      startTime: "2024-06-01T10:00:00",
      endTime: "2024-06-01T11:00:00",
      attendedCount: 8,
      totalCount: 10,
      comment: true,
      feedbackCount: 5,
      feedbackTotal: 10,
      status: "IN_PROGRESS",
      roomLink: "#1",
    },
    {
      num: 2,
      mentor: "이멘토 (mentor02)",
      subject: "영어",
      operatingDate: "2024-06-05",
      startTime: "2024-06-05T14:00:00",
      endTime: "2024-06-05T15:30:00",
      attendedCount: 10,
      totalCount: 10,
      comment: false,
      feedbackCount: 0,
      feedbackTotal: 10,
      status: "UPCOMING",
      roomLink: "#2",
    },
    {
      num: 3,
      mentor: "박멘토 (mentor03)",
      subject: "과학",
      operatingDate: "2024-05-20",
      startTime: "2024-05-20T09:00:00",
      endTime: "2024-05-20T10:30:00",
      attendedCount: 6,
      totalCount: 12,
      comment: true,
      feedbackCount: 3,
      feedbackTotal: 12,
      status: "ENDED",
      roomLink: "#3",
    },
    {
      num: 4,
      mentor: "최멘토 (mentor04)",
      subject: "국어",
      operatingDate: "2024-06-07",
      startTime: "2024-06-07T16:00:00",
      endTime: "2024-06-07T17:30:00",
      attendedCount: 0,
      totalCount: 10,
      comment: false,
      feedbackCount: 0,
      feedbackTotal: 10,
      status: "CANCELLED",
      roomLink: "#4",
    },
    {
      num: 5,
      mentor: "오멘토 (mentor05)",
      subject: "사회",
      operatingDate: "",
      startTime: "",
      endTime: "",
      attendedCount: null as any,
      totalCount: null as any,
      comment: false,
      feedbackCount: null as any,
      feedbackTotal: null as any,
      status: "UPCOMING",
      roomLink: "#",
    },
  ],
};

export const SCYR_OPTIONS = {
  CL01: [
    { value: "1", label: "초1" },
    { value: "2", label: "초2" },
    { value: "3", label: "초3" },
    { value: "4", label: "초4" },
    { value: "5", label: "초5" },
    { value: "6", label: "초6" },
  ],
  CL02: [
    { value: "1", label: "중1" },
    { value: "2", label: "중2" },
    { value: "3", label: "중3" },
  ],
  CL03: [
    { value: "1", label: "고1" },
    { value: "2", label: "고2" },
    { value: "3", label: "고3" },
  ],
};

export const SCYR_MAP = {
  CL01: {
    "1": "초1",
    "2": "초2",
    "3": "초3",
    "4": "초4",
    "5": "초5",
    "6": "초6",
  },
  CL02: {
    "1": "중1",
    "2": "중2",
    "3": "중3",
  },
  CL03: {
    "1": "고1",
    "2": "고2",
    "3": "고3",
  },
};

export const weekdayCodeMap = { MON: "월", TUE: "화", WED: "수", THU: "목", FRI: "금", SAT: "토", SUN: "일" };

export const weekdayOptions = [
  { label: "월", value: "MON" },
  { label: "화", value: "TUE" },
  { label: "수", value: "WED" },
  { label: "목", value: "THU" },
  { label: "금", value: "FRI" },
  { label: "토", value: "SAT" },
  { label: "일", value: "SUN" },
];

export const validateMessage = {
  password: '영문대문자/영문소문자/숫자/특수문자 중 3가지 이상 포함 8~16자로 입력해 주세요.',
  email: '올바른 이메일 주소를 입력해 주세요',
  mobile: '000-0000-0000 형태로 입력해 주세요',
}
